// extracted by mini-css-extract-plugin
module.exports = {"center":"CenterLoader_center__lfvHv"};